import DerivativeRankingStatCalculatorBase from "../calculators/derivativeRankingStatCalculators/DerivativeRankingStatCalculatorBase.js";

class DerivativeRankingStatCalculatorSelector{
    constructor(calculators) {
        if (typeof(calculators) === 'undefined') {
            calculators = [];
        }
        else if (!(calculators instanceof Array)) {
            throw new TypeError('calculators must ba an array');
        }

        this.calculators = [];

        for (const calculator of calculators) {
            this.register(calculator);
        }
    }

    register(calculator) {
        if (!(calculator instanceof DerivativeRankingStatCalculatorBase)) {
            throw new TypeError('calculator must be an instance inheriting from DerivativeRankingStatCalculatorBase');
        }

        this.calculators.push(calculator);
        return this;
    }

    selectAll(parameter) {
        return this.calculators.filter(c => c.canCalculate(
            parameter
        ));
    }

    selectAny(parameter) {
        return this.calculators.find(c => c.canCalculate(
            parameter
        ));
    }
}

export default DerivativeRankingStatCalculatorSelector;